<div class="page-layout" [class.dashboard-layout]="router.url.includes('/' + ROUTES.ACCOUNT.ROOT)">
  <!-- HEADER -->
  <app-header class="header" />
  <!-- HEADER -->
  <!-- BODY -->
  <div class="content">
    <router-outlet></router-outlet>
  </div>
  <!-- BODY -->
  <!-- FLOORING/WALLING BANNER SECTION -->
  @if(showBanner) {
  <app-flooring-walling-banner-section />
  }
  <!-- FLOORING/WALLING BANNER SECTION -->
  <!-- FOOTER -->
  <app-footer class="footer" />
  <!-- FOOTER -->
</div>